import { render, staticRenderFns } from "./charge.vue?vue&type=template&id=b5991a12&scoped=true"
import script from "./charge.vue?vue&type=script&lang=js"
export * from "./charge.vue?vue&type=script&lang=js"
import style0 from "./charge.vue?vue&type=style&index=0&id=b5991a12&prod&scoped=true&lang=css"
import style1 from "./charge.vue?vue&type=style&index=1&id=b5991a12&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5991a12",
  null
  
)

export default component.exports